/** Max annotated evidence rows fetched per field for distribution previews. */
export const EVIDENCE_SAMPLE_SIZE = 250;
